import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { LS_PROCTORING_AUTH_TOKEN } from "utils/constants"
import { get as getCookie } from "utils/cookie"

const prepareHeaders = (headers: Headers) => {
  const proctoringToken = localStorage.getItem(LS_PROCTORING_AUTH_TOKEN)
  if (proctoringToken) {
    headers.set("X-Session-Token", proctoringToken)
  }

  // @ts-ignore - Global auth token set by external script
  const jwt = window.__AUTH_TOKEN__
  if (jwt) {
    headers.set("X-User-Token", jwt)
  }
  const accessToken = getCookie("access_token")
  if (accessToken) {
    headers.set("Authorization", `Bearer ${accessToken}`)
  }
  return headers
}

const baseMobilePairingQuery = fetchBaseQuery({
  baseUrl: process.env.NEXT_PUBLIC_PROCTORING_BASE_URL,
  prepareHeaders,
})

interface GetQrCodeResponse {
  qrcode: string
  link: string
}

interface GetQrCodeArgs {
  endpoint?: string
}

const mobilePairingService = createApi({
  reducerPath: "mobilePairing",
  tagTypes: [],
  baseQuery: baseMobilePairingQuery,
  endpoints: (build) => ({
    getQrCode: build.query<GetQrCodeResponse, GetQrCodeArgs>({
      query: (args) => ({
        method: "GET",
        url: args.endpoint || "/api/v1/proctoring/plugins/dual_camera/qr_code",
      }),
    }),
    getPollingData: build.query({
      query: ({ endpoint }) => ({
        method: "GET",
        url: endpoint || "/api/v1/proctoring/events",
      }),
    }),
    validateImagePosition: build.mutation({
      query: ({ imageFile }) => {
        const formData = new FormData()
        if (imageFile) {
          formData.append("image", imageFile)
        }

        return {
          url: "/api/rt/orientation-check",
          method: "POST",
          body: formData,
        }
      },
    }),
    sendProctorEvent: build.mutation({
      query: ({ eventType, eventName, endpoint, extraData = {} }) => ({
        url: endpoint || "/api/v1/proctoring/events",
        method: "POST",
        body: {
          events: [
            {
              type: eventType,
              name: eventName,
              data: extraData,
            },
          ],
        },
      }),
    }),
  }),
})

export const {
  useGetQrCodeQuery,
  useValidateImagePositionMutation,
  useGetPollingDataQuery,
  util: mobilePairingEvent,
  useSendProctorEventMutation,
} = mobilePairingService

export default mobilePairingService
